import { useEffect, useState } from "react";
import { Flex, useBreakpointValue } from "@chakra-ui/react";

import { ClassifDTO } from "../../../dtos/ClassifDTO";
import DTPaginate from "./DTPaginate";
import DTTable from "./DTTable";
import DTSearch from "./DTSearch";
import DTCards from "./DTCards";

interface DTClassifParams {
	data: ClassifDTO[];
	setModalClassifVisible: (param: boolean) => void;
	setClassifModal: (param: ClassifDTO) => void;
	onOpenAlertDelete: () => void;
}

const DTClassif: React.FC<DTClassifParams> =({ 
	data,
	setModalClassifVisible,
	setClassifModal,
	onOpenAlertDelete
}) => {
	const isWideVersion = useBreakpointValue({
		base: false,
		lg: true,
	});

	const [loading, setLoading] = useState(true);

	const [pesqClassifs, setPesqClassifs] = useState<ClassifDTO[]>(data);
	const [classifs, setClassifs] = useState<ClassifDTO[]>(data);

	const [sort, setSort] = useState({ por: '', cres: true });
	const [controls, setControls] = useState({
		page: 1,
		perPage: 10,
		totalPage: Math.ceil(data.length / 10),
	});

	useEffect(() => {
		setClassifs(data.slice(0, 10));
		setLoading(false);
	}, []);

	async function handleUpdateList(
		page: number,
		perPage: number,
		classifss: ClassifDTO[],
	) {
		const auxPage = page - 1;
		const start = auxPage * perPage;
		const end = start + perPage;

		setClassifs(classifss.slice(start, end));
	}

	return (
		<Flex w="100%" flexDir="column">
			<DTSearch
				classifs={data}
				setPesqClassifs={setPesqClassifs}
				controls={controls}
				setControls={setControls}
				handleUpdateList={handleUpdateList}
			/>

			{isWideVersion && (
				<DTTable
					classifs={classifs}
					pesqClassifs={pesqClassifs}
					sort={sort}
					setSort={setSort}
					controls={controls}
					handleUpdateList={handleUpdateList}
					setModalClassifVisible={setModalClassifVisible}
					setClassifModal={setClassifModal}
					onOpenAlertDelete={onOpenAlertDelete}
				/>
			)}

			{!isWideVersion && !loading && (
				<DTCards
					classifs={classifs}
					setModalClassifVisible={setModalClassifVisible}
					setClassifModal={setClassifModal}
					onOpenAlertDelete={onOpenAlertDelete}
				/>
			)}

			<DTPaginate
				pesq_length={pesqClassifs.length}
				pesqClassifs={pesqClassifs}
				controls={controls}
				setControls={setControls}
				handleUpdateList={handleUpdateList}
			/>
		</Flex>
	);
};

export default DTClassif;